import React, { useEffect, useRef } from 'react';
import { Icon } from '../Icon/Icon.js';
const styles = {"banner":"Banner-module__banner__8c4fD","text":"Banner-module__text__VApz5","title":"Banner-module__title__IRRqM","body":"Banner-module__body__AMuPY"};
const TONE_ICONS = {
    error: 'alert',
    info: 'info',
    success: 'check-circle'
};
/**
 * A message above a form (Foundations · Feedback board, frames D6–D8 and F1). An error is an alert and takes focus
 * when it appears; info and success are polite status messages.
 */
export function Banner({ tone, title, body }) {
    const bannerRef = useRef(null);
    const isError = tone === 'error';
    useEffect(() => {
        if (tone === 'error') {
            bannerRef.current?.focus();
        }
    }, [tone, title]);
    return (React.createElement("div", { ref: bannerRef, className: styles.banner, role: isError ? 'alert' : 'status', tabIndex: isError ? -1 : undefined, "data-tone": tone },
        React.createElement(Icon, { name: TONE_ICONS[tone], size: 20 }),
        React.createElement("span", { className: styles.text },
            React.createElement("span", { className: styles.title }, title),
            body !== undefined && React.createElement("span", { className: styles.body }, body))));
}
//# sourceMappingURL=Banner.js.map